/**
 * 供货路由模块
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/supply',
  name: '供货',
  component: Layout,
  redirect: '/supply/goods',
  children: [
    {
      name: '商品',
      path: 'goods',
      component: () => import('@/views/supply/goods/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_goods'
      }
    },
    {
      name: '添加商品',
      path: 'goods/goods',
      component: () => import('@/views/supply/goods/components/AddGoods.vue'),
      meta: {
        father: {
          name: '商品',
          path: '/supply/goods'
        }
      }
    },
    {
      name: '品类',
      path: 'category',
      component: () => import('@/views/supply/category/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_category'
      }
    },
    {
      name: '商品排序',
      path: 'good-sort',
      component: () => import('@/views/supply/category/components/GoodSort.vue')
    },
    {
      name: '面料分类',
      path: 'fabric',
      component: () => import('@/views/supply/fabric/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_fabric'
      }
    },
    {
      name: '材质',
      path: 'material',
      component: () => import('@/views/supply/material/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_material'
      }
    },
    {
      name: '库存',
      path: 'stock',
      component: () => import('@/views/supply/stock/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_stock'
      }
    },
    // {
    //   name: '专辑',
    //   path: 'album',
    //   component: () => import('@/views/supply/album/Index.vue')
    // },
    {
      name: '专辑',
      path: 'album',
      component: () => import('@/views/supply/newAlbum/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_album'
      }
    },
    {
      name: '设置专辑',
      path: 'album/add',
      component: () => import('@/views/supply/newAlbum/components/add.vue'),
      meta: {
        father: {
          name: '专辑',
          path: '/supply/album'
        }
      }
    },
    {
      name: 'POD版型',
      path: 'podModel',
      component: () => import('@/views/supply/podModel/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_podModel'
      }
    },
    {
      name: '评论',
      path: 'review',
      component: () => import('@/views/supply/review/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_review'
      }
    },
    {
      name: 'Vision Studio',
      path: 'visionStudio',
      component: () => import('@/views/supply/visionStudio/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_visionStudio'
      }
    },
    {
      name: 'Fabric Library',
      path: 'fabricLibrary',
      component: () => import('@/views/supply/fabricLibrary/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'supply_fabricLibrary'
      }
    }
  ]
}
